import * as React from "react";

const Loading = () => {
    return (<>
        <div className="loader medium" />
    </>);
}
export default Loading;